module.exports = __webpack_public_path__ + "img/partner 16.30643c5e.jpg";